import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import moment from 'moment';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';

const UpdatedField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	const inputValue = deviceForFullInfo?.updatedDate
		? `${moment(deviceForFullInfo.updatedDate).format('MM/DD/YYYY h:mm:ss A')}      ${deviceForFullInfo.updatedBy}`
		: undefined;

	return <FullInfoField label="lastUpdateLabel" value={inputValue} />;
};

export default UpdatedField;
